import { Injectable } from "@angular/core";
import { IOrganization, Organization } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class OrganizationsApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Organizations", // Theme !
      [], // Post route paths
      ["organizations"], // Get route paths
      [], // Update route paths
      [] // Delete route paths
    );
  }

  public listSome(code: string, country?: string): Observable<Organization[]> {
    return this.api.get(this.readRoutes[0], { code, country: country ? country : undefined }).pipe(
      map((values: IOrganization[]) => {
        return values.map((v) => new Organization(v));
      })
    );
  }
}
